module.exports = __webpack_public_path__ + "img/icon-service.c8122ef1.svg";